export default "__VITE_ASSET__Dkl8z4DK__"